import { ConnectedRouter } from 'connected-react-router';
import React from 'react'
import { hot } from 'react-hot-loader/root'
import { Provider } from 'react-redux'

// import 'bootstrap/dist/css/bootstrap.min.css';
import Pages from './manual/Pages';
import configureStore, { history } from './manual/store';

const store = configureStore({});
function App() {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Pages />
      </ConnectedRouter >
    </Provider>
  );
}

export default hot(App);
